module.exports = __webpack_public_path__ + "media/flags/af-1c6658c2.svg";